<template>
	<div class="chat-container w-100 position-relative" style="margin-bottom: -60px;">
    <div id="hotel-check-in"></div>
    <div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="">
                  <div class="w-100 bg-green box-shadow-nav p-3">
                    <div class="row">
                      <div class="col-8 text-left">
                        <p class="mb-0 ml-2 body-1-2 font-semibold text-white">{{$t('hotel.concierge.pre-checkin-form')}}</p>
                      </div>
                      <div class="col-4 text-right">
                        <div @click="toggleLanguage(true)" style="top:0px !important">
                          <img :src="data.image_url" class="p-0 language border" v-for="data in getMerchant().language" v-if="data.iso_code == getCurrentLanguage()" style="top: 0px;">
                          <i class="language-i text-right text-white simple-icon-arrow-down" style="top: 0px;"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="height-50px"></div>
    <!-- LANGUAGE -->
    <Language v-if="language" :data="true" @toggleLanguage="toggleLanguage"></Language>
    <!-- POP UP BG -->
    <popUpBG v-if="language"></popUpBG>

    <popup-detail 
      id_ref="success_trx"
      direction="bottom" 
      :show="warning.show"
      use_max_size
      wrapper_size="mobile"
      use_footer
      no_close_backdrop
      @close="toggleWarning">
      <template v-slot:body>
        <div class="py-5 px-4 text-center">
          <div class="rounded-100 my-2 w-20 mx-auto">
            <div class="bg-green rounded-100 mx-auto size-icon-in">
              <img src="../../../assets/img/icon/correct-white.png" width="40" style="margin: 20px 20px">
            </div>
          </div>
          <p class="mb-0 body-2-2 text-18 text-green font-extrabold">{{warning.title}}</p>
          <p class="mb-2 body-2-2">{{warning.body}}</p>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-3 pt-3">
          <template v-if="warning.title == 'Reservation not match'">
            <div class="row slim-grid-row">
              <div class="col-6">
                <button 
                  @click="goToHomePage"
                  class="g-btn g-btn-dark g-btn-lg w-100" >
                  Cancel
                </button>
              </div>
              <div class="col-6">
                <state-button size="lg" variant="primary" block :click="changeReservation">
                  Yes, Countinue
                </state-button>
              </div>
            </div>
          </template>
          <button 
            v-else
            @click="goToHomePage"
            class="g-btn g-btn-primary g-btn-lg w-100" >
            Homepage
          </button>
        </div>
      </template>
    </popup-detail>
    <warning-box 
      v-if="reservation_active"  
      @yes="loadDetailTrx"
      @no="goToHomePage"
      :title="$t('warning-message.active-reservation.title')"
      :body="$t('warning-message.active-reservation.desc_1')+active_room_type+$t('warning-message.active-reservation.desc_2')"
      btn_primary="Yes"
      btn_secondary="No" /> 
    <template v-else>	
      <div class="mt-4 bg-white">
        <div class="my-5 py-3 text-center" v-if="is_load"> 
          <loader />
        </div>
        <template v-else>
          <div class="p-4" v-if="error != ''">
            <ErrorMessage :message="error" />
          </div>
          <template v-else>
            <div class="container px-4 pt-2 bg-light-page border-bottom mb-4">
              <CheckinData v-if="show_list" :data="header_data" :show_room="false" ></CheckinData>
            </div>
            <div class="px-4 pb-5">
              <RoomList v-if="show_list" :data="reservation.room_type_list" ></RoomList>
            </div>
          </template>
        </template>
     	 </div>
    </template>
	</div>
</template>
<script>
 	import {mapGetters,mapMutations} from 'vuex';
 	import CheckinData from '@/components/hotel/concierge/checkin/CheckinData'
 	import RoomList from '@/components/hotel/concierge/checkin/RoomList'
  import WarningBox from '@/components/general/WarningBox'
  import Language from '@/components/hotel/concierge/general/Language'
  import popUpBG from '@/components/hotel/concierge/general/popUpBG'
  import {post,get} from '@/services/index.js';
  import moment from 'moment'

	export default{
		components:{
			CheckinData,
			RoomList,
      WarningBox,
      Language,
      popUpBG
		},
    metaInfo(){
      return {
        title: 'Reservation List',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
		data(){
			return {
        show_list: false,
        is_load: false,
        reservation: {},
        header_data: {},
        error: '',
        warning:{
          show: false,
          title: this.$t('warning-message.concierge-auth.title'),
          body: this.$t('warning-message.concierge-auth.desc')
        },
        reservation_active: false,
        active_room_type: '',
        language: false
      }
		},
    computed:{
      pms_detail_id(){
        let id = this.$route.query.pms_detail_id
        return id ? id : ''
      }
    },
		mounted(){
      this.validateData()
		},
    created(){
      if(this.$route.query.token == undefined){
        this.warning.show = true
      }
    },
		methods:{
			...mapGetters(['getMerchant','getConciergeAuth','getIsConciergeAuth','getCurrentLanguage','getMetaTitleTemplate','getIsConciergeAuthWithPinOrToken','isNotLogin']),
      ...mapMutations(['setConciergeAuth','resetConciergeAuth']),
      // GENERAL
      validateData(){
        if(!this.warning.show){
          if(this.pms_detail_id != ''){
            this.$router.push(`/${this.getMerchant().code}/concierge/precheckin-form/${this.pms_detail_id}?booking_number=${this.$route.params.booking_number}&token=${this.$route.query.token}`)
          }else{
            this.is_load = true
            // get data from url
            this.loadRsvWithBookingNumber(true)
            .then(res=>{
              this.setupReservationDataForPage(res)
            })
            .catch(err=>{
              if(err == 'pin not match'){
                this.warning.show = true
              }else{
                this.error = err
              }
            }).finally(()=>this.is_load = false)
          }
          
        }
      },
      goToHomePage(){
        this.$router.push(`/${this.getMerchant().code}`)
      },
      toggleLanguage(data){
        this.language = data
      },
      toggleWarning(){
        this.warning.show = !this.warning.show
      },
      setupReservationDataForPage(data){
        let total_room = data.room_type_list.reduce((acc,x)=>acc + x.detail_list.length,0)
        let first_room = data.room_type_list[0].detail_list[0]
        if(total_room == 1){
          this.$router.push(`/${this.getMerchant().code}/concierge/precheckin-form/${first_room.pms_detail_id}?booking_number=${this.$route.params.booking_number}&token=${this.$route.query.token}`)
        }else{
          this.reservation = data
          this.show_list = true
          this.header_data = {
            merchant: this.getMerchant(),
            detail:{
              check_in: first_room.arrival_date,
              check_out: first_room.departure_date,
              adult: first_room.adult,
              child: first_room.child,
              special_request: first_room.special_request
            },
            guest: data.booked_by,
            total_rooms: total_room,
            room_type: this.$isNotEmpty(data.room_type) ? data.room_type.name : 'Unallocated Room Type' ,
            room: this.$isNotEmpty(data.room) ? data.room.name : 'Unallocated Room' ,
            rate: this.$isNotEmpty(data.rate) ? data.room.name : '-' ,
          }
          this.is_load = false
        }
      },
      changeReservation(){
        return new Promise((success,fail)=>{
          this.$logout()
          let params = [
            {
              key : 'booking_number',
              value: this.$route.params.booking_number
            },
            {
              key : 'token',
              value: this.$route.query.token
            }
          ]
          this.setConciergeAuth(params)
          this.setupReservationDataForPage(this.reservation)
          setTimeout(()=>{
            this.toggleWarning()
            success()
          },300)
        })
      },

      // API
      loadRsvWithBookingNumber(with_temp_token=false){
        return new Promise((success,fail)=>{ 
          let custom_header = with_temp_token ? 
          { type:'concierge_token_direct', token:this.$route.query.token} : 
          'concierge_token'
          let api_url = with_temp_token ? this.$route.params.booking_number : this.getConciergeAuth().booking_number
          get("CONCIERGE","booking/"+api_url,{
            merchant_id: this.getMerchant().id
          },custom_header).then(response=>{
            let res = response.data
            if(res.success){
              success(res.data)
            }else{
              fail(res.message)
            }
          })
        })
      },
      loadRsvWithPMSDetailId(detail_id){
        return new Promise((success,fail)=>{
          get("CONCIERGE",`reservation/${detail_id}`,{
            merchant_id: this.getMerchant().id
          }).then(response=>{
            if(response.data.success){
              success(response.data.data)
            }else{
              fail(response.data.message)
            }
          })
        })
      },
		}
	}
</script>
<style scoped>
	@media screen and (max-width: 992px) {
		.mobile-none{
			display: none !important;
		}
	}
  .border-green {
    border: 1px solid #79A33A !important;
  }

  .top-6px{
    top: 6px!important;
  }

  .h-check-in{
    height: 100vh;
    min-height: 100%
  }

</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/PreCheckinRoomList.vue